import { Injectable } from '@zhfe/vue2-di-plugin'
import { Store } from 'vuex'
import client from '@/client/'

/** 上报数据类型 */
export interface ReportHomeOperate {
  main_click?:number,
  main_hover?: number,
  sub_mode?: number,
  user_login?: number
}

@Injectable()
export class VideoHomeService {
  constructor () {}

  reportInterestsShow ({ contentTitle, contentIndex }) {
    client.home.REPORT.reportHomeContentShow({
      show_content2: contentTitle,
      show_content: contentIndex,
    })
  }

  reportHomeOperate (params: ReportHomeOperate) {
    client.home.REPORT.reportHomeOperate(params)
  }
}
